import { useEffect, useState } from 'react';
import { swrFetcher } from 'contexts/user/index';
import { TeamResponse } from 'lib/teams';
import useSWR from 'swr';

const usePlans = () => {
  const [hasPlan, setHasPlan] = useState<boolean>(false);
  const [proUserPlans, setProUserPlans] = useState<TeamResponse[]>([]);
  const [teamPlans, setTeamPlans] = useState<TeamResponse[]>([]);
  const [hasLoaded, setLoaded] = useState<boolean>(false);

  const { data: teams } = useSWR<TeamResponse[]>('/api/teams', swrFetcher);

  useEffect(() => {
    if (!teams) {
      return;
    }

    teams.sort((a, b) =>
      (a.name ?? a.username)
        .toLowerCase()
        .localeCompare((b.name ?? b.username).toLowerCase())
    );

    const ownedPlans = teams.filter((team) => team.permission === 'Owner');
    setHasPlan(ownedPlans.length > 0);
    setTeamPlans(teams);
    setProUserPlans([]);

    setLoaded(true);
  }, [teams]);

  return { hasPlan, teamPlans, proUserPlans, hasLoaded };
};

export default usePlans;
